window.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM fully loaded and parsed");

  // document.querySelector('.faq-item').classList.add('first-faq');
  // document.querySelector(".faq-item").classList.add("active-faq");
  const faqItem = document.querySelector(".faq-item");
  if (faqItem) {
    faqItem.classList.add("first-faq");
    faqItem.classList.add("active-faq");
  }

  let faq_heading = document.querySelectorAll(".faq-heading");
  faq_heading.forEach((heading) =>
    heading.addEventListener("click", (e) => {
      let parent = e.target.closest(".faq-item");
      let key = parent.dataset.key;

      faq_heading.forEach((h) => {
        let p = h.closest(".faq-item");
        let k = p.dataset.key;
        if (k !== key) {
          if (p.classList.contains("active-faq")) {
            p.classList.remove("active-faq");
            $(p.querySelector(".faq-details")).slideUp();
          }
        } else {
          p.classList.toggle("active-faq");
          $(p.querySelector(".faq-details")).slideToggle();
        }
      });
    })
  );
});
